module.exports = __webpack_public_path__ + "img/icon-idea.569bd9a3.svg";